import { collection, getDocs, query, where } from 'firebase/firestore'
import { defineStore } from 'pinia'
import { callBackend, db } from '@/plugins/firebase'

export const useCouponStore = defineStore('couponStore', {
  state: () => ({
    coupon: null,
  }),
  actions: {
    async validateCoupon({ code, organizationId, projectId, priceOptionId, itemTypes }) {
      try {
        const response = await callBackend('payments/coupons/validate', {
          code,
          organizationId,
          projectId,
          priceOptionId,
          itemTypes
        })

        // Backend `payments/coupons/validate` wraps the result under `data`:
        // { success: true, data: { valid, coupon } }. Legacy stripe/* endpoint
        // returned the flat shape, so unwrap once here.
        const payload = response?.data || response

        if (payload?.valid) {
          this.coupon = payload.coupon
          return { error: null, coupon: payload.coupon }
        } else {
          this.coupon = null
          return { error: payload?.error, message: payload?.message }
        }
      } catch (error) {
        this.coupon = null
        const backendError = error?.response?.data?.error
        return { error: backendError?.code || 'NETWORK_ERROR', message: backendError?.message }
      }
    },
    async getCoupon({ code, organizationId }) {
      const q = query(collection(db, 'coupons'), where('code', '==', code), where('organizationId', '==', organizationId))
      const querySnapshot = await getDocs(q)
      querySnapshot.forEach(doc => { this.coupon = doc.data() })
    },
    deleteCoupon() {
      this.coupon = null
    },
  },
})
